import { call, put, takeLatest } from "redux-saga/effects";
import { loginUser, logoutUser, registerUser, profileUpdate, currentProfile } from "./utils";
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutSuccess,
  registerFailure,
  registerSuccess,
  registerRequest,
  logoutRequest,
  profileUpdateRequest,
  profileUpdateFailure,
  profileUpdateSuccess,
  getProfileDetails,
  getProfileDetailsSuccess,
} from "./slice";
import { message } from "antd";

function* handleRegister(action) {
  try {
    const response = yield call(registerUser, action.payload);

    localStorage.setItem("token", response.data.data.token);
    // localStorage.setItem("user", JSON.stringify(response.data.data.details));

    yield put(
      registerSuccess({
        token: response.data.data.token,
        user: response.data.data.details,
      }),
    );

    message.success("User registered successfully!");
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Registration failed";
    yield put(registerFailure(errorMsg));
    message.error(errorMsg);
  }
}

function* handleLogin(action) {
  try {
    const response = yield call(loginUser, action.payload);

    localStorage.setItem("token", response.data.data.token);
    // localStorage.setItem("user", JSON.stringify(response.data.data.details));

    yield put(
      loginSuccess({
        token: response.data.data.token,
        user: response.data.data.details,
      }),
    );
    message.success("user logined sucessfully");
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Login failed";
    yield put(loginFailure(errorMsg));
  }
}

function* handleLogout(action) {
  try {
    const token = localStorage.getItem("token");
    yield call(logoutUser, token);
    localStorage.removeItem("token");
    yield put(logoutSuccess());

  } catch(error)  {
    const errorMsg = error?.response?.data?.message || "Login failed";
    yield put(loginFailure(errorMsg));
  } finally {
    message.success("user logout sucessfully");
  }
}

function* getProfile(action) {
  try {
    const token = localStorage.getItem("token");
    const response = yield call(currentProfile, token);
    yield put(getProfileDetailsSuccess(response.data.data));
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Failed to fetch user details";
    // yield put(fetchProfileError(errorMsg));
    message.error(errorMsg);
  }
}

function* handleProfile(action) {
  try {
    const token = localStorage.getItem("token");
    const response = yield call(profileUpdate, token, action.payload);
    yield put(profileUpdateSuccess(response.data));
    message.success("Profile updated successfully");
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Failed to update profile";
    yield put(profileUpdateFailure(errorMsg));
    message.error(errorMsg);
  }
}
export default function* authSaga() {
  yield takeLatest(registerRequest.type, handleRegister);
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(logoutRequest.type, handleLogout);
  yield takeLatest(profileUpdateRequest.type, handleProfile);
  yield takeLatest(getProfileDetails.type, getProfile);
}
